export enum IepFormTypeEnum {
  None = 0,
  FormAccomodations = 11,
  FormAgeOfMajority17 = 21,
  FormAgeOfMajority18 = 12,
  FormAssessmentTeamSummary = 23,
  FormAuthorizationForDisclosure = 9,
  FormBehaviorPlan = 6,
  FormCaliforniaAssessmentTest = 35,
  FormConferenceFollowup = 3,
  FormConferenceInvitation = 5,
  FormELReclassification = 36,
  FormESYEligibilityWorksheet = 40,
  FormESYSurvey = 34,
  FormGoalsAndBenchmarks = 10,
  FormIndividualizedTransitionPlan = 13,
  FormLAGO = 18,
  FormManifestationDetermination = 32,
  FormMeetingSignInSheet = 26,
  FormNotes = 15,
  FormNoticeOfIntent = 8,
  FormNotificationOfAppeal = 20,
  FormPermissionToAssess = 4,
  FormPermToAssessRemind = 7,
  FormPlanningForTheFuture = 17,
  FormPresentLevels = 38,
  FormPsychomotorObservation = 27,
  FormRevokingConsent = 24,
  FormSignature = 14,
  FormSpecialFactors = 37,
  FormStudentInformation = 16,
  FormSummaryOfPerformance = 30,
  FormSurrogateParentAppointment = 25,
  FormVisionHearing = 19,
  FormEmergencyServicesOptions = 39
}
